import React, { ReactElement } from 'react';
import { Checkbox } from '../../../../../components/CiscoUi';

export type FilterItemProps = {
  label: string;
  isChecked: boolean;
  onChange: VoidFunction;
};

export const FilterItem = ({
  label,
  isChecked,
  onChange,
}: FilterItemProps): ReactElement => {
  return (
    <span className="half-margin-top">
      <Checkbox
        data-testid={`template-visibility-filter-${label}`}
        label={label}
        checked={isChecked}
        onChange={onChange}
      />
    </span>
  );
};
